import styles from './GridLoader.module.scss';

const GridLoader = () => {
  return (
    <div className={styles.GridLoader}>
      {[...Array(6)].map((_, rowIndex) => (
        <div key={rowIndex} className={styles.GridRow}>
          {[...Array(6)].map((_, colIndex) => {
            // Calculate delay: column determines when to start, row determines offset within column
            const delay = colIndex * 0.1 + (5 - rowIndex) * 0.016;
            return (
              <div 
                key={colIndex} 
                className={styles.GridSquare}
                style={{ animationDelay: `${delay}s` }}
              ></div>
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default GridLoader;
